/**
 * Sistema di animazioni del sito: una sola curva, tre durate, tre effetti.
 * Serve a tenere tutto coerente, invece di avere durate diverse per sezione.
 */

// Curva di uscita morbida, parte veloce e si posa piano.
export const CURVA = [0.22, 1, 0.36, 1];

export const DURATA = {
  hover: 0.3,
  testo: 0.6,
  blocco: 0.9,
  reveal: 1.1,
};

// Sfasamento fra elementi affiancati: sotto i 100ms sembra vivo, sopra sembra una lista che carica.
export const SFASAMENTO = 0.07;

// L'animazione parte appena la sezione entra nello schermo.
export const VISTA = { once: true, amount: 0.1, margin: "0px 0px -8% 0px" };

// Solo dissolvenza, senza spostamenti: usata ovunque tranne che sulle due
// card delle strutture, che sono le uniche a salire.
export const dissolvenza = {
  nascosto: { opacity: 0 },
  visibile: (i = 0) => ({
    opacity: 1,
    transition: {
      duration: DURATA.blocco,
      delay: i * SFASAMENTO,
      ease: "easeOut",
    },
  }),
};

// Salita corta: piu il movimento e' breve, piu sembra costoso.
export const salita = {
  nascosto: { opacity: 0, y: 24 },
  visibile: (i = 0) => ({
    opacity: 1,
    y: 0,
    transition: { duration: DURATA.testo, delay: i * SFASAMENTO, ease: CURVA },
  }),
};

export const bloccoGrande = {
  nascosto: { opacity: 0, y: 24 },
  visibile: (i = 0) => ({
    opacity: 1,
    y: 0,
    transition: { duration: DURATA.blocco, delay: i * SFASAMENTO, ease: CURVA },
  }),
};

/**
 * Reveal fotografico. Il contenitore ha overflow-hidden e il contenuto sale
 * da sotto: solo trasformazioni, niente clip-path, quindi funziona ovunque
 * e il browser lo gestisce sulla GPU.
 */
/**
 * Contenitore fermo che fa da innesco. Serve che abbia lui stesso `variants`,
 * altrimenti framer non lo tratta come nodo di varianti e lo stato non scende
 * ai figli. Gli stati sono vuoti: non anima niente, fa solo da interruttore.
 */
export const GRUPPO = { nascosto: {}, visibile: {} };

export const revealSu = {
  nascosto: { y: "101%", opacity: 0 },
  visibile: (i = 0) => ({
    y: "0%",
    opacity: 1,
    transition: {
      y: { duration: DURATA.reveal, delay: i * SFASAMENTO, ease: CURVA },
      // La dissolvenza chiude prima dello scorrimento: il bordo che avanza
      // non si legge piu' come una linea netta.
      opacity: { duration: 0.7, delay: i * SFASAMENTO, ease: "easeOut" },
    },
  }),
};

export const revealFoto = {
  nascosto: { scale: 1.08 },
  visibile: {
    scale: 1,
    transition: { duration: DURATA.reveal + 0.3, ease: CURVA },
  },
};
